export const BUSINESS_CASE_PDF_URL =
  "https://leadershipedgelive.s3.us-west-2.amazonaws.com/Leadership_Edge_Live_Business_Case.pdf";

export function BusinessCaseButton({
  onDark = false,
  className = "",
}: {
  onDark?: boolean;
  className?: string;
}) {
  const style = onDark
    ? "border-white/70 text-white hover:bg-white/10"
    : "border-[#693D94] text-[#693D94] hover:bg-[#693D94]/5";
  return (
    <a
      href={BUSINESS_CASE_PDF_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex shrink-0 items-center justify-center rounded-[6px] border-2 px-6 py-3 text-sm font-semibold transition-all hover:-translate-y-0.5 ${style} ${className}`}
    >
      Download the business case (PDF)
    </a>
  );
}
